import * as React from "react";
import { ChromeNavGeneric } from "./ChromeNavGeneric";

export const ChromeNavCreateEvent = () => (
  <ChromeNavGeneric
    hideBackBtn
    label="Event details"
    labelStyle={{ margin: "1px auto 0px auto" }}
    settings
    feedback
  />
);
